module.exports = __webpack_public_path__ + "static/media/sider-mobile-logo.50a4d66f.svg";